import { Component, EventEmitter, Output, QueryList, ViewChildren, input } from '@angular/core';
import { ListViewFilterTagComponent } from '@coin/shared/core/feature-legacy-components';
import { ListViewFilterTag, ListViewTagFilterParameter } from '@coin/shared/core/util-models';
import { Observable } from 'rxjs';

@Component({
  selector: 'customer-list-view-filter-bar',
  templateUrl: './list-view-filter-bar.component.html',
  styleUrls: ['./list-view-filter-bar.component.scss'],
  standalone: false
})
export class ListViewFilterBarComponent {
  @ViewChildren(ListViewFilterTagComponent) filterItems: QueryList<ListViewFilterTagComponent>;
  readonly tags = input<ListViewFilterTag[]>([]);
  readonly filterParameter$ = input<Observable<ListViewTagFilterParameter[]>>(undefined);

  @Output() addFilterEvent: EventEmitter<ListViewTagFilterParameter> = new EventEmitter<ListViewTagFilterParameter>();
  @Output() removeFilterEvent: EventEmitter<ListViewTagFilterParameter> =
    new EventEmitter<ListViewTagFilterParameter>();
  @Output() resetFiltersEvent: EventEmitter<void> = new EventEmitter<void>();

  public addFilter(parameter: ListViewTagFilterParameter): void {
    this.addFilterEvent.emit(parameter);
  }

  public removeFilter(parameter: ListViewTagFilterParameter): void {
    this.removeFilterEvent.emit(parameter);
  }

  public resetFilters(): void {
    this.filterItems.forEach(filterItem => filterItem.reset());
    this.resetFiltersEvent.emit();
  }
}
